import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { BinCardProvider } from '../partner/binCard/ContextAPI';
import Index from '../partner/binCard/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerBinCard() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-bin-card']) return <PermissionDenied />;

    return (
        <BinCardProvider>
            <Index />
        </BinCardProvider>
    );
}
